import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import fastDelivery from "../../../../Assets/Images/Icons/FastDelivery.png";
import strategy from "../../../../Assets/Images/Icons/Strategy.png";
import price from "../../../../Assets/Images/Icons/Price.png";
import image1 from "../../../../Assets/Images/HeroSection/Image1.png";
import image2 from "../../../../Assets/Images/HeroSection/Image2.png";
import { heroContent } from "../../../../Constants/content";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
    const navigate = useNavigate();
  return (
    <div className="hero-image">
      <Container className="hero-section d-flex align-items-center justify-content-center text-center position-relative">
        <h3 className="bg-light px-3 py-2 rounded-5 shadow-sm">
          {heroContent[0]}
        </h3>

        <h1 className="col-12 col-md-10 fw-bold mt-0 mt-lg-3">
          {heroContent[1]}
        </h1>

        <p className="text-muted mt-0 mt-lg-3">{heroContent[2]}</p>

        <Button
          className="my-5 collab-btn rounded-5 py-2 py-lg-3 px-2 px-lg-3 btn"
          onClick={() => navigate("/contactUs")}
        >
          Collaborate with Us
        </Button>

        <Row className="btn-section d-flex justify-content-between align-items-center container">
          <Col xs={2} md={3} lg={3}>
            <Image
              src={image1}
              fluid
              alt="Hero illustration 1"
              className="tilt-image"
            />
          </Col>

          <Col
            xs={8}
            md={6}
            lg={6}
            className="d-flex flex-column align-items-center justify-content-center gap-1 gap-lg-3 my-0 my-md-3"
          >
            <div className="d-flex flex-row justify-content-between w-100">
              <Button
                variant="light"
                size="sm"
                className="rounded-5 btn-delivery"
              >
                <Image
                  src={fastDelivery}
                  alt="Fast delivery icon"
                  className="hero-btn-icon"
                  fluid
                />{" "}
                {heroContent[4]}
              </Button>

              <Button variant="light" className="rounded-5 btn-strategy">
                <Image
                  src={strategy}
                  alt="Strategy icon"
                  className="hero-btn-icon"
                />{" "}
                &nbsp; {heroContent[5]}
              </Button>
            </div>

            <Button variant="light" className="rounded-5 btn-pricing">
              <Image src={price} alt="Pricing icon" className="hero-btn-icon" />{" "}
              {heroContent[6]}
            </Button>
          </Col>

          <Col xs={2} md={3} lg={3}>
            <Image
              src={image2}
              fluid
              alt="Hero illustration 2"
              className="tilt-image"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
